<template>
  <v-sheet :width="width" :max-width="maxWidth" :min-width="minWidth" :class="[{ 'inline-flex': inline }]">
    <span
      :class="[
        { 'blue-grey--text text--lighten-1': !titleColorClass },
        { 'field--required': required && !hideRequired },
        { 'gap-2': !!label },
        titleClass,
        titleColorClass,
      ]"
      class="d-flex align-center font-weight-medium mb-2"
    >
      <span>{{ label }}</span>
      <slot name="label-extra"></slot>
    </span>
    <span v-if="!!subtitle" class="blue-grey--text text--lighten-1">
      {{ subtitle }}
    </span>
    <slot></slot>
  </v-sheet>
</template>

<script>
export default {
  name: 'FieldLabel',
  props: {
    label: String,
    subtitle: String,
    required: Boolean,
    minWidth: [String, Number],
    maxWidth: [String, Number],
    width: [String, Number],
    titleClass: String,
    titleColorClass: String,
    inline: Boolean,
    hideRequired: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.field--required::before {
  content: '*';
  color: red;
  margin-right: -4px;
}
.inline-flex {
  display: flex;
  column-gap: 16px;
  align-items: center;
}
</style>
